var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-switcher", class: _vm.rootClasses }, [
    _c("div", { staticClass: "mobile-switcher--element" }, [
      _c("div", { staticClass: "mobile-switcher--element-wrap" }, [
        _c("div", { staticClass: "mobile-switcher--active-bg" }),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-switcher--buttons" }, [
          _c("div", { staticClass: "mobile-switcher--button" }, [
            _c(
              "button",
              {
                staticClass: "mobile-switcher--btn mobile-switcher--btn__list",
                on: {
                  click: function($event) {
                    return _vm.onClick(_vm.states.LIST)
                  }
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "mobile-switcher--icon" },
                  [_c("ui-icon", { attrs: { symbol: "list", size: "small" } })],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobile-switcher--button" }, [
            _c(
              "button",
              {
                staticClass: "mobile-switcher--btn mobile-switcher--btn__map",
                on: {
                  click: function($event) {
                    return _vm.onClick(_vm.states.MAP)
                  }
                }
              },
              [
                _c(
                  "span",
                  { staticClass: "mobile-switcher--icon" },
                  [_c("ui-icon", { attrs: { symbol: "map", size: "small" } })],
                  1
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fd78dca", { render: render, staticRenderFns: staticRenderFns })
  }
}